
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import Component from "vue-class-component";
import Vue from "vue";
import QualificationTable from "../components/qualifications-tabel.vue";

@Component({
    components: {
        HeadingWave,
        QualificationTable
    }
})
export default class Qualifications extends Vue {
}
